export default "__VITE_ASSET__DaGKtrLQ__"